import React from 'react';
import PropTypes from 'prop-types';

import ProfileTitle from './ProfileTitle';
import ProfileDescription from './ProfileDescription';
import ProfileHomePageLink from './ProfileHomePageLink';

export default function ProfileInfo({ profile }) {
    return (
        <section className="panel u-mb32 u-pb8">
            <ProfileTitle text={profile.companyName} />
            <ProfileDescription text={profile.description} />
            <ProfileHomePageLink url={profile.homePageUrl} />
        </section>
    );
}

ProfileInfo.propTypes = {
    profile: PropTypes.object.isRequired,
    className: PropTypes.string,
};
